module.exports = __webpack_public_path__ + "img/hunan.c16af60c.png";